module.exports = __webpack_public_path__ + "img/face62.3ae1c706.gif";